import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import React, { ReactNode } from 'react';

type ElevatedContainerProps = {
  children: ReactNode;
};
const ElevatedContainer: React.FC<ElevatedContainerProps> = ({ children }) => (
  <div css={[sectionContainerStyles, elevatedContainerStyles]}>{children}</div>
);

export default ElevatedContainer;

const sectionContainerStyles = css({
  padding: `${token('space.400')} ${token('space.300')}`,
  '@media (max-width: 767px)': {
    padding: `${token('space.300')} ${token('space.200')}`,
  },
});

const elevatedContainerStyles = css({
  borderRadius: '8px',
  width: '100%',
  boxShadow: token('elevation.shadow.raised'),
  backgroundColor: token('elevation.surface'),
});
